<wbo-select-option [value]="KvdDisplayType.QUEUE" label="wbo.order-processor.edit.option.kvdDisplayType.queue">
</wbo-select-option>
<wbo-select-option [value]="KvdDisplayType.PREP" label="wbo.order-processor.edit.option.kvdDisplayType.prep">
</wbo-select-option>
<wbo-select-option [value]="KvdDisplayType.EXPEDITOR" label="wbo.order-processor.edit.option.kvdDisplayType.expeditor">
</wbo-select-option>
